import { IChartBackendService } from "./types";

type QueuedHttp = { post: Function };
type ApiPathLike = { table: { getSummaryTableDataUrl: (id: string | number) => string } };

export class TreemapBackendServiceTS {
  private readonly queuedHttp: QueuedHttp;
  private readonly apiPath: ApiPathLike;
  private readonly chartBackendService: IChartBackendService;

  constructor(queuedHttp: QueuedHttp, apiPath: ApiPathLike, chartBackendService: IChartBackendService) {
    this.queuedHttp = queuedHttp;
    this.apiPath = apiPath;
    this.chartBackendService = chartBackendService;
  }

  async fetchJson(tableId: string | number, chartIndex: number, requestParams: any) {
    const url = this.apiPath.table.getSummaryTableDataUrl(tableId) + "?chart_index=" + chartIndex;
    return this.queuedHttp.post(url, requestParams);
  }

  getRepresentation(resultData: any) {
    const rowFieldNames = resultData.config.rows.map((d: any) => d.field_name);
    const valueFieldNames = resultData.config.values.map((d: any) => d.field_name);
    const rowParsers = resultData.config.rows.map((d: any) => this.chartBackendService.getParserForType(d.data_type));
    const valueParsers = resultData.config.values.map((d: any) =>
      this.chartBackendService.getParserForType(d.data_type)
    );
    return {
      config: JSON.parse(JSON.stringify(resultData.config)),
      values: resultData.values.map((valueObj: any) => ({
        columns: {},
        rows: valueObj.rows.map((_: any, i: number) => {
          const rowFieldName = rowFieldNames[i];
          return { [rowFieldName]: rowParsers[i](valueObj.rows[i][rowFieldName]) };
        }),
        values: valueFieldNames.reduce((accumulator: any, valueFieldName: string, index: number) => {
          accumulator[valueFieldName] = valueParsers[index](valueObj.values[valueFieldName]);
          return accumulator;
        }, {}),
      })),
    };
  }
}

export function createAngularCompatibleTreemapService(
  queuedHttp: QueuedHttp,
  apiPath: ApiPathLike,
  chartBackendService: IChartBackendService
) {
  const service = new TreemapBackendServiceTS(queuedHttp, apiPath, chartBackendService);
  return {
    fetchJson: service.fetchJson.bind(service),
    getRepresentation: service.getRepresentation.bind(service),
  };
}

